import { stats } from "@/mocks/homeData";

export default function StatsBar() {
  return (
    <section className="relative z-20 py-6 md:py-8 px-4 md:px-8 lg:px-12">
      <div className="max-w-6xl mx-auto">
        <div className="bg-background-50 rounded-2xl border border-background-200/70 shadow-xl shadow-background-200/20 p-6 md:p-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
            {stats.map((stat, i) => (
              <div
                key={i}
                className="reveal text-center"
                style={{ transitionDelay: `${i * 100}ms` }}
              >
                <div className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-primary-600 mb-1">
                  {stat.number}
                </div>
                <div className="text-xs md:text-sm text-foreground-600 font-medium">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}